import endpoints from "hooks/api/endpoints";
import useApiGet, { UseApiGetOptions } from "hooks/api/useApiGet";
import AccountFeatureDto from "types/AccountFeatureDto";
import MultipleItemResponse from "types/MultipleItemResponse";

export default function useGetProjectFeatures(
  projectId?: string | null,
  options?: UseApiGetOptions,
) {
  const { result, ...rest } = useApiGet<
    MultipleItemResponse<AccountFeatureDto>
  >(projectId ? endpoints.getProjectFeatures(projectId) : null, options);

  return { features: result?.dataList ?? [], ...rest };
}
